import type { BrowserRequirement } from '../../platform/support/browser-support';

/**
 * What a family sees when this browser cannot run the game (DEP-03, MIN §23).
 *
 * Written for the grown-up, because they are the one who can do something about it, and written to
 * be *useful*: it says what is missing in terms of what the game needs it for, and it names the one
 * action that actually helps. It names no browser and no version — the app never asked which
 * browser this is (see `browser-support.ts`), so it is in no position to recommend one.
 *
 * COPY FLAG (grown-up strings, joins the pending copy table): every string below.
 */
export function UnsupportedBrowserScreen({ missing }: { missing: readonly BrowserRequirement[] }) {
  return (
    <main className="error-screen" role="alert" data-testid="unsupported-browser">
      <h1>This browser cannot run the game</h1>
      <p className="lede">
        Thrive Games needs a few things this browser does not offer. Nothing is wrong with your
        computer, and nothing has been lost.
      </p>
      <p>The game uses these for:</p>
      <ul>
        {missing.map((requirement) => (
          <li key={requirement.id} data-testid={`unsupported-${requirement.id}`}>
            {requirement.whatItIsFor}
          </li>
        ))}
      </ul>
      <p>
        Opening this page in an up-to-date browser is usually all it takes. Everything the game does
        happens on this computer, so there is nothing to sign in to and nothing to move across.
      </p>
    </main>
  );
}
